import { render, staticRenderFns } from "./DefaultPenalties.vue?vue&type=template&id=03a42404&"
import script from "./DefaultPenalties.vue?vue&type=script&lang=js&"
export * from "./DefaultPenalties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports